<template>
    <BreadCrumb PageTitle="Details du BESC" />
    <ViewBesc/>
  </template>
  
  <script lang="ts">
  
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ViewBesc from "@/components/BESC/ViewBesc.vue";

    export default defineComponent({
      name: "ViewBescPage",
      components: {
        BreadCrumb,
        ViewBesc,
      },
    });
  </script>